<template lang="pug">
.container(id="PlayListEditor-container" @click='setNoPlayitemsSelected()')
  .items-container(
      v-if='playListWithContentSimple',
      @dragenter="dragEnterPlayList(playListWithContentSimple, $event)",
      :class="{ 'full-height': simpleMode }",
      @click.self='closeRightClickMenu()'
    )
    .navi-buttons
      el-button.button(
        :class="{ 'warning': playlistChangedByOtherUser }",
        id="PlayListEditor-reloadPlaylistButton",
        size='small',
        type='text',
        @click='playlistChangedByOtherUser = false; reloadPlaylist()',
        :title="playlistChangedByOtherUser ? $t('Playlist was changed by other user. Click to reload.') : $t('Reload playlist')"
      )
        font-awesome-icon(icon="sync")
      el-button.button(
        :class="{ 'warning': compactViewActive }",
        id="PlayListEditor-compactViewButton",
        size='small',
        type='text',
        @click='toggleCompactView()',
        :title="compactViewActive ? $t('Normal view') : $t('Compact view')"
      )
        font-awesome-icon(icon="bars")
      el-button.button(
        :class="{ 'warning': restrictionViewActive }",
        id="PlayListEditor-restrictionViewButton",
        size='small',
        type='text',
        @click='toggleRestrictionView()',
        :title="restrictionViewActive ? $t('Close restrictions') : $t('Show restrictions')"
      )
        font-awesome-icon(icon="clock")
    .playitem-row(
      v-for="item in playListWithContentSimple.PlayListItems",
      :key="item.id",
      :id="'PlayListEditor-playitemRow' + item.id",
      draggable="draggable",
      :class="{ active: itemIsSelectedByProp(item), isSelected: itemIsSelectedByStore(item), 'drag-over-left': dropedIntoItem && (item.id === dropedIntoItem.id) && dragDirection === 'left', 'drag-over-right': dropedIntoItem && (item.id === dropedIntoItem.id) && dragDirection === 'right' }"
      @dragstart="dragStartPlayItem(item, $event)",
      @dragend="dragEndPlayItem(item, $event)",
      @dragenter="dragEnterPlayItem(item, $event)",
      @click.stop="setPlayItemsSelected(item, $event); closeRightClickMenu()",
      @dblclick="handleDblClick(item)",
      @contextmenu='openRightClickMenu(item, $event)',
    )
      .playitem-top-line
        .cell.thumbnail(v-if='!compactViewActive')
          img(:src='getMediumThumbnailPath(item)', @click="playMedium(item)")
        .cell.medium-data(@dblclick="handleDblClick(item)")
          .container-name
            MediumIcon.icon(:medium="item.Medium", :class="{ test: item.Medium.test }")
            span.name-button {{ item.order + 1 }}. {{ item.Medium.name }}
          .params
            .cell
              span(v-if='item.File && item.Medium.type !== "PlayListLayout"') {{ item.File.originalWidthPixels }} x {{ item.File.originalHeightPixels }}
              span(v-else) {{ item.Medium.playListLayoutWidth }} x {{ item.Medium.playListLayoutHeight }}
            .cell
              span(:class="{ 'warning': item.playDurationMs > 0 }") {{ msToDuration(getDurationForPlayItem(item)) }}
        .medium-tags(v-if='!compactViewActive')
          MediumTagsShortInfo(:mediumId='item.Medium.id')
        .cell.restriction-buttons
          el-button.restriction-button(
            type='text', size="mini", :title='$t("Display Properties")',
            :id="'PlayListEditor-playitem' + item.id + 'DisplayButton'",
            :class="{ 'has-restriction': itemHasPlayRestrictions(item) }",
            @click="showPlayListItemModify({item, restriction: 'PlayProperties'})"
          )
            font-awesome-icon(icon="palette")
          el-button.restriction-button(
            type='text', size="mini", :title='$t("Time restrictions")',
            :id="'PlayListEditor-playitem' + item.id + 'TimeRestrictionButton'",
            :class="{ 'has-restriction': itemHasTimeRestrictions(item) }",
            @click="showPlayListItemModify({item, restriction: 'TimeRestrictions'})"
          )
            font-awesome-icon(:class="{ 'danger': itemWillNeverBePlayed(item) }", icon="clock")
          el-button.restriction-button(
            type='text', size="mini", :title='$t("Exeptions for players")',
            :id="'PlayListEditor-playitem' + item.id + 'ExceptionsButton'",
            :class="{ 'has-restriction': itemHasPlayerExeptions(item) }",
            @click="showPlayListItemModify({item, restriction: 'PlayerExeptions'})"
          )
              font-awesome-icon(icon="ban")
          el-button.restriction-button(
            type='text', size="mini", :title='$t("Synchronization")',
            :id="'PlayListEditor-playitem' + item.id + 'SynchronizationButton'",
            :class="{ 'has-restriction': itemHasSynchroRestrictions(item) }",
            @click="showPlayListItemModify({item, restriction: 'Synchro'})"
          )
            font-awesome-icon(icon="stopwatch")
      .playitem-restriction-line(v-if='restrictionViewActive')
        ScheduleDateList(:id="'PlayListEditor-scheduleDateList' + item.id" :restrictions='item.PlayListItem_DateRestrictions')
        ScheduleDayTimeList(:id="'PlayListEditor-scheduleDayTimeList' + item.id" :restrictions='item.PlayListItem_DaytimeRestrictions', dayLabelLength='short')
  el-container(v-if='!playListWithContentSimple')
    i.el-icon-loading
    span &nbsp; {{ $t('Rendering playlist content')}}
  el-dialog(:close-on-click-modal="false", :visible.sync="playListItemUnlinkVisible", @close='closePlayListItemUnlink()', append-to-body)
    PlayListItemUnlink(
      ref='PlayListItemUnlink',
      :playListItem="unlinkPlayListItem",
      :playList="playList",
      @close-playListItemUnlink='closePlayListItemUnlink'
    )
  el-dialog(:close-on-click-modal="false", :visible.sync="playMediumVisible", @close='playMediumVisible = false; playedMedium = undefined',  append-to-body, width='65%')
    Player(:playedMedium='playedMedium', @close-PlayMedium="closePlayMedium()")
  el-dialog(
    :close-on-click-modal="false",
    :visible.sync="modifyPlayListItemVisible",
    @close='closePlayListItemModify()',
    width="80%",
    append-to-body,
  )
    PlayListItemModify(
      v-if='modifyPlayListItemVisible',
      :playListItem='modifyPlayListItemItem',
      :playList='playList',
      :modifyRestriction="modifyRestriction",
      @close='closePlayListItemModify()',
      @reloadPlaylist='reloadPlaylist()'
    )
  RightClickPlayItemMenu(
    ref='RightClickPlayItemMenu',
    @showPlayListItemModify='showPlayListItemModify',
    @showMediumBasicEditor='showMediumBasicEditor',
    @showPlayListItemUnlink='showPlayListItemUnlink'
    @loadMediumUsageInMediaEditor='loadMediumUsageInMediaEditor',
    @extractIntoPlaylist='extractIntoPlaylist',
    @extractIntoLayout='extractIntoLayout',
    @copyTimeRestrictions='copyTimeRestrictions',
    @copyPlayerExceptions='copyPlayerExceptions',
    @copyPlayProperties='copyPlayProperties',
    @copySynchroListener='copySynchroListener',
    @pasteTimeRestrictions='pasteTimeRestrictions',
    @pastePlayerExceptions='pastePlayerExceptions',
    @pastePlayProperties='pastePlayProperties',
    @pasteSynchroListener='pasteSynchroListener',
    @clearTimeRestrictions='clearTimeRestrictions',
    @clearPlayerExceptions='clearPlayerExceptions',
    @clearPlayProperties='clearPlayProperties',
    @clearSynchroListener='clearSynchroListener',
    @clonePlayitems='clonePlayitems'
  )
  el-dialog(:close-on-click-modal="false",
    :visible.sync="mediumBasicEditorVisible",
    @close='closeMediumBasicEditor()',
    append-to-body, width="60%"
  )
    MediumBasicEditor(id="PlayListEditor-mediumBasicEditor" v-if='editedMedium', :mediumId='editedMedium.id')
  el-dialog(:close-on-click-modal="false",
    :visible.sync="extractPlayitemsVisible",
    @close='closeExtractPlayitems()',
    append-to-body, width="45%"
  )
    DialogExtractPlayitems(:choice='extractPlaylistType', @linkerJobDone='extractJobDone')
  el-dialog(:close-on-click-modal="false",
    :visible.sync="clonePlayitemsVisible",
    append-to-body, width="45%"
  )
    DialogClonePlayitems(v-if='clonePlayitemsVisible', :choice='extractPlaylistType', @linkerJobDone='cloneJobDone')
</template>

<script>
import Vue from 'vue'
import MediumIcon from './../Common/MediumIcon'
import PlayListItemModify from './PlayListItemModify'
import PlayListItemUnlink from './PlayListItemUnlink'
import MediumBasicEditor from './MediumBasicEditor'
import DialogExtractPlayitems from '../Linker/DialogExtractPlayitems'
import DialogClonePlayitems from '../Linker/DialogClonePlayitems'
import ScheduleDateList from '../Common/ScheduleDateList'
import ScheduleDayTimeList from '../Common/ScheduleDayTimeList'
import Player from './../File/Player'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'
import RightClickPlayItemMenu from './RightClickPlayItemMenu'
import MediumTagsShortInfo from './MediumTagsShortInfo'
import editorMethods from './EditorMethods.mixin'

export default {
  mixins: [textUtils, mediaUtils, editorMethods],
  async created () {
    if (!this.onlyPreview) {
      await this.$store.dispatch('Medium/clearMediaSelectedRight')
      await this.$store.dispatch('Medium/addSelectedRight', [this.playList])
    }
    await this.loadData()
    Vue.$io.socket.off('Playlist_changed')
    Vue.$io.socket.on('Playlist_changed', data => {
      if (this.playListWithContentSimple && this.playListWithContentSimple.id === data.playlistId && this.$store.state.User.user.id !== data.userId) {
        console.log(this.$store.state.User.user.id, data.userId)
        this.playlistChangedByOtherUser = true
      }
    })
    this.compactViewActive = this.$store.state.User.user.compactViewActive
    this.restrictionViewActive = this.$store.state.User.user.restrictionViewActive
  },
  components: {
    PlayListItemUnlink,
    ScheduleDateList,
    ScheduleDayTimeList,
    RightClickPlayItemMenu,
    Player,
    MediumIcon,
    PlayListItemModify,
    MediumBasicEditor,
    DialogExtractPlayitems,
    DialogClonePlayitems,
    MediumTagsShortInfo
  },
  props: {
    'playList': {
      required: true
    },
    'selectedPlayitemId': {
      required: false
    },
    'onlyPreview': {
      required: false
    },
    'simpleMode': {
      required: false
    }
  },
  data () {
    return {
      errors: {},
      playListWithContentSimple: undefined,
      dragedItem: undefined,
      dropedIntoItem: undefined,
      savingOrderIsProgress: false,
      unlinkPlayListItem: undefined,
      playListItemUnlinkVisible: false,
      mediumBasicEditorVisible: false,
      playMediumVisible: false,
      modifyPlayListItemVisible: false,
      rightMenuVisible: false,
      extractPlayitemsVisible: false,
      clonePlayitemsVisible: false,
      editedMedium: undefined,
      playedMedium: undefined,
      modifyRestriction: 'PlayProperties',
      rightClickedItem: undefined,
      top: '0px',
      left: '0px',
      extractPlaylistType: undefined,
      dragDirection: undefined,
      playlistChangedByOtherUser: false,
      compactViewActive: false,
      restrictionViewActive: false
    }
  },
  watch: {
    playList: async function (newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        this.playListWithContentSimple = undefined
        await this.loadData()
      }
    },
    droppedOntoPlaylist: async function (newVal, oldVal) {
      if (!newVal && oldVal) {
        console.error('droppedOntoPlaylist')
        await this.loadData()
      }
    }
  },
  methods: {
    toggleRestrictionView () {
      this.restrictionViewActive = !this.restrictionViewActive
      this.setViewPreference()
    },
    toggleCompactView () {
      this.compactViewActive = !this.compactViewActive
      this.setViewPreference()
    },
    async setViewPreference () {
      await Vue.axios.post('user/setViewPreference', {
        restrictionViewActive: this.restrictionViewActive,
        compactViewActive: this.compactViewActive
      })
      await this.$store.dispatch('User/getMe')
    },
    closeExtractPlayitems () {
      this.extractPlayitemsVisible = false
      this.extractPlaylistType = undefined
    },
    clonePlayitems () {
      this.clonePlayitemsVisible = true
    },
    async cloneJobDone () {
      this.clonePlayitemsVisible = false
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    async extractJobDone () {
      this.closeExtractPlayitems()
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    getPlayListFromStore (playlistMediumId) {
      const playlist = this.$store.state.Medium.media_list.find(medium => medium.id === playlistMediumId)
      return playlist
    },
    openRightClickMenu (item, $event) {
      this.$refs.RightClickPlayItemMenu.openRightClickMenu(item, $event)
    },
    closeRightClickMenu () {
      this.$refs.RightClickPlayItemMenu.closeRightClickMenu()
    },

    closeMediumBasicEditor () {
      this.editedMedium = undefined
      this.mediumBasicEditorVisible = false
    },
    setPlayItemsSelected (item, $event) {
      if (!$event.shiftKey) {
        if (!$event.ctrlKey && !$event.metaKey) {
          this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', [item])
        } else {
          this.$store.commit('Medium/TOGGLE_PLAYITEM_SELECTED_RIGHT', item)
        }
      }
      if ($event.shiftKey) {
        if (!$event.ctrlKey && !$event.metaKey) {
          const previouslySelectedItemOrder = this.$store.state.Medium.playitems_selected_right[this.$store.state.Medium.playitems_selected_right.length - 1].order
          const startOrder = previouslySelectedItemOrder < item.order ? previouslySelectedItemOrder : item.order
          const endOrder = previouslySelectedItemOrder < item.order ? item.order : previouslySelectedItemOrder
          this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', this.playListWithContentSimple.PlayListItems.filter((pli) => {
            return (pli.order <= endOrder) && (pli.order >= startOrder)
          }))
          this.playListWithContentSimple.PlayListItems.filter((pli) => {
            return startOrder <= pli.order <= endOrder
          })
        } else {
          console.log('TODO - Shift-shrink playitems selection (shift + ctrl)')
        }
      }
    },
    setNoPlayitemsSelected () {
      this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', [])
    },
    selectAll () {
      this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', this.playListWithContentSimple.PlayListItems)
    },
    getDurationForPlayItem (playitem) {
      if (playitem.Medium.type.indexOf('PlayList') > -1) {
        return playitem.playDurationMs > 0 ? playitem.playDurationMs : playitem.Medium.playListDurationMs
      }
      if (playitem.playDurationMs > 0) {
        return playitem.playDurationMs
      }
      if (playitem.File.originalDurationMs > 0) {
        return playitem.File.originalDurationMs
      }
      return 5000
    },
    dragStartPlayItem (item, e) {
      if (this.dropedIntoItem || this.dragedItem) return
      this.dragedItem = item
      // e.target.style.opacity = 0.1
      e.dataTransfer.setData('text/plain', 'dummy') // fix for FireFox bug
    },
    async reloadPlaylist () {
      this.playListWithContentSimple = await this.$store.dispatch('Medium/getPlaylistContentSimple', this.playList)
      this.dropedIntoItem = undefined
      this.dragedItem = undefined
    },
    async dragEndPlayItem (item, e) {
      if (
        this.savingOrderIsProgress ||
        (!this.dropedIntoItem || !this.dragedItem) ||
        (this.dropedIntoItem.order === this.dragedItem.order)
      ) {
        this.$store.dispatch('Medium/resetDraggedOverPlayitem')
        this.dropedIntoItem = undefined
        this.dragedItem = undefined
        this.savingOrderIsProgress = false
        return
      }
      this.savingOrderIsProgress = true
      let direction
      if (this.dropedIntoItem.order < this.dragedItem.order) {
        direction = 'left'
      } else {
        direction = 'right'
      }
      await this.$store.dispatch('Medium/movePlaylistItemOrderRewrite',
        {
          direction: direction,
          playListItem: this.dragedItem,
          desiredOrder: this.dropedIntoItem.order
        }
      )
      this.$store.dispatch('Medium/resetDraggedOverPlayitem')
      await this.reloadPlaylist()
      this.broadcastPlaylistChanged()
      this.savingOrderIsProgress = false
    },
    dragEnterPlayItem (item, e) {
      // if (!this.dragedItem) return
      if (this.dragedItem && item.order < this.dragedItem.order) {
        this.dragDirection = 'left'
      } else {
        this.dragDirection = 'right'
      }
      this.dropedIntoItem = item
      this.$store.dispatch('Medium/setDropAllowed', true)
      this.$store.dispatch('Medium/setDraggedOverPlayitem', { id: item.id, dragDirection: this.dragDirection })
    },
    dragEnterPlayList (item, e) {
      this.$store.dispatch('Medium/setDropAllowed', true)
    },
    playMedium (item) {
      let medium = item.Medium
      medium.File = item.File
      this.playedMedium = medium
      this.playMediumVisible = true
    },

    showPlayListItemUnlink (item) {
      this.playListItemUnlinkVisible = true
      this.unlinkPlayListItem = item || {}
      // this.unlinkPlayListItem.PlayList = this.playListWithContentSimple
    },
    async closePlayListItemUnlink () {
      this.playListItemUnlinkVisible = false
      this.unlinkPlayListItem = undefined
      await this.reloadPlaylist()
      this.broadcastPlaylistChanged()
    },

    async closePlayListItemModify () {
      this.modifyPlayListItemVisible = false
      this.modifyPlayListItemItem = undefined
      await this.reloadPlaylist()
      this.broadcastPlaylistChanged()
    },
    itemIsSelectedByProp (item) {
      if (parseInt(this.selectedPlayitemId) === item.id) return true
    },
    itemIsSelectedByStore (item) {
      return this.$store.state.Medium.playitems_selected_right.findIndex(pi => pi.id === item.id) > -1
    },
    async loadData () {
      this.playListWithContentSimple = undefined
      this.dropedIntoItem = undefined
      this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_RIGHT', [])
      await this.reloadPlaylist()
      this.$emit('playlistDataUpdate', { playListDurationMs: this.playListWithContentSimple.playListDurationMs, itemsLength: this.playListWithContentSimple.PlayListItems.length })
    },
    getMediumName (medium) {
      if (medium.type !== 'PlayListDesktop') {
        return medium.name
      }
      return `${this.$t('Local Playlist of ')}${this.fullNameOfDesktopPlaylist(medium)}`
    }
  },
  computed: {
    summarizePlayListItemsDurations () {
      if (this.playListWithContentSimple.PlayListItems.length === 0) return 0
      const durations = []
      for (const playitem of this.playListWithContentSimple.PlayListItems) {
        if (playitem.playDurationMs > 0) {
          durations.push(playitem.playDurationMs)
          continue
        }
        if (playitem.File && playitem.File.originalDurationMs > 0) {
          durations.push(playitem.File.originalDurationMs)
          continue
        }
        if (playitem.Medium.type === 'Image') {
          durations.push(5000)
        }
      }
      if (durations.length > 0) {
        return durations.reduce((partialSum, a) => partialSum + a)
      }
      return ''
    },
    // FIXME DRY
    copiedDateTimeRestrictionExistsInStore () {
      return this.$store.state.Clipboard.copied_playlistitem_daytime_restrictions.length !== 0 ||
        this.$store.state.Clipboard.copied_playlistitem_date_restrictions.length !== 0
    },
    mediaSelectedRightLength () {
      if (this.$store.state.Medium.media_selected_right.length === 0) return false
      if (!this.$store.state.Medium.media_selected_right[0].PlayListItems) return false
      return this.$store.state.Medium.media_selected_right[0].PlayListItems.length
    },
    droppedOntoPlaylist () {
      if (this.$store.state.Medium.media_selected_right.length === 0) return false
      return this.$store.state.Medium.media_selected_right[0].dropped
    },
    noDialogsVisible () {
      return !this.playListItemUnlinkVisible &&
      !this.mediumBasicEditorVisible &&
      !this.playMediumVisible &&
      !this.modifyPlayListItemVisible &&
      !this.rightMenuVisible &&
      !this.extractPlayitemsVisible
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.warning {
  color: $--color-warning;
}
.navi-buttons {
  border: 0px solid red;
  margin-top: 6px;
  .button {
    border: 0px solid green;
    margin: 0px;
    margin-left: 10px;
    padding: 0px;
    float:right;
    color: $--color-text-secondary;
    &.warning {
      color: $--color-warning;
    }
  }
}
.title {
  font-size: $--font-size-big;
}
.summarized-duration {
  color:$--color-text-secondary;
}
.items-container {
  display: flex;
  flex-direction: column;
  padding-top: 2px;
  &.full-height {
    min-height: 82vh;
  }
  .playitem-row {
    border-bottom: $--border-light;
    // border: 0px dotted red;
    padding: 5px 10px;
    margin: 0px;
    &.active {
      color: $--color-warning;
    }
    &.isSelected {
      background-color: $--background-color-selected;
    }
    &.drag-over-left {
      border-top: 5px $--border-style-base rgba($--border-color-extra-light, 0.2)
    }
    &.drag-over-right {
      border-bottom: 5px $--border-style-base rgba($--border-color-extra-light, 0.2)
    }
  }
  .playitem-restriction-line {
    display: flex;
    padding-bottom: 0px;
  }
  .playitem-top-line {
    display: flex;
    align-items: center;
    font-size: $--font-size-base;
    padding: 0px 0px 0px 0px;
    // cursor: ns-resize;
    justify-content: space-between;
    .thumbnail {
      width: 84px;
      cursor: zoom-in;
      img {
        margin-top: 3px;
        max-width: 60px;
        max-height: 60px;
      }
    }
    .medium-data {
      width: 50%;
      overflow: hidden;
      text-align: left;
      margin-right: 20px;
      margin-left: 5px;
      display: flex;
      .icon {
        color: $--color-text-placeholder;
        &.test {
          color: mix($--color-white, $--color-text-regular-green, 30%);
        }
      }
      .container-name {
        width: 85%;
      }
      .params {
        color: $--color-text-secondary;
        font-size: $--font-size-small;
      }
      .name-button {
        color: $--color-text-regular;
        font-size: $--font-size-base;
        margin-left: 8px;
      }
    }
    .medium-tags {
      width: 30%;
    }
    .duration {
      // width: 10%;
      float: right;
      color: $--color-text-secondary;
    }

    .restriction-buttons {
      margin: 0px 0px 0px 0px;
      padding: 0px 0px 0px 0px;
      text-align: right;
      display: flex;
      width: 10%;
      justify-content: flex-end;
      .restriction-button {
        color: $--color-text-secondary;
        padding: 0px 0px;
        &.has-restriction {
          color: $--color-warning;
          &:hover {
            color: $--color-text-primary;
          }
          display: inline;
        }
      }
    }
    .action-buttons {
      border: 0px solid blue;
    }
  }
}
.has-restriction {
  color: $--color-warning;
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/Medium/PlayListEditor.vue